import React, { useRef } from 'react'
import './blog.css';
import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'

//import reportWebVitals from './reportWebVitals';

const Event = () => {
  const ref = useRef(null);

  return (
    <div>
      <br></br>
      <div className='blog__container'>
        <div className="row">
          <div className="first-column">
              <div class className="teamTitle-wrapper">
                <p id="teamTitle">RSVP for WiC Events</p>
              </div>
             <section className="words">
             <p>WiC is dedicated to providing informative and fun social events in the Allen School community. 
             Such events include company networking sessions, research panels, community-building, tech talks,
             diversity discussions, Winter Affiliates Dinner, and high school outreach initiatives.</p>
            </section>
            <div>
            <iframe title="WiC events calendar" src="https://calendar.google.com/calendar/embed?src=c_a8794f22a14d156673a836a956256dc9a1854dc19ed356ab9d505e2d8490aba1%40group.calendar.google.com&ctz=America%2FLos_Angeles" style={{border: 0}} width="800" height="600" frameBorder="0" scrolling="no"></iframe>
            </div>
          </div> 
        </div>
    </div>

      <div className='actions' ref={ref}>
          <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' rel="noreferrer" className='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank' rel="noreferrer" className='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' aria-label="Instagram" target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' aria-label="Facebook" target='_blank' rel="noreferrer"><BsFacebook/></a>
          <a id='discord' href='https://discord.gg/Zp4GVB7ddq' aria-label="Discord" target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Event;


